<template>
  <div class="d-flex flex-row content" v-resize="handleShrinkTitle">
    <div class="map" v-if ="viewMode=='showAll' || viewMode=='showMap'">
      <v-toolbar  style="z-index: 1" color="primary">
        <img v-if="!smallestScreen" src="@/assets/logo.png" style="height: 40px" >
        <v-toolbar-title v-if="bigScreen"  class="white--text" >
        <h1 style="float:left; padding-right: 10px" > ELEMENT Air </h1>
        <h1 style="color:orange; float:right;"> BETA</h1>
        </v-toolbar-title>
        <v-tooltip bottom v-if="smallestScreen" mandatory flat class="ml-0">
          <v-btn large dark @click="toggleMapLoc" slot="activator" icon>
            <v-icon v-if="viewMode=='showMap'">list</v-icon>
            <v-icon v-else >map-marked</v-icon>
          </v-btn>
          <span>Toggle Locations and Map</span>
        </v-tooltip>


        <v-btn-toggle v-if="!bigScreen && !smallestScreen " mandatory v-model="viewMode" flat class="ml-3">
          <v-btn large value="showMap" flat>
            Show Map
          </v-btn>
          <v-btn large value="showLocations" flat>
            Show Locations
          </v-btn>
        </v-btn-toggle>
<!--
        <v-menu bottom left   v-if="(viewMode=='showMap') && smallestScreen" mandatory flat class="ml-0">
          <v-btn
          slot="activator"
          dark
          large
          icon
          >
          <v-icon> wifi</v-icon>
        </v-btn>
        <v-list>
          <v-list-tile
          v-for="(item, index) in viewSelection"
          :key="index"
          @click="pointMode=item.tag"
          >
          <v-list-tile-title>{{ item.title }}</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>


    <v-btn-toggle v-if ="(viewMode=='showAll' || viewMode=='showMap') && !smallestScreen" mandatory v-model="pointMode" flat class="ml-3">
      <v-btn large value="none" flat>
        None
      </v-btn>
      <v-btn large value="disabled" flat>
        Only Disabled
      </v-btn>
      <v-btn large value="enabled" flat>
        Only Enabled
      </v-btn>
      <v-btn large value="all" flat>
        All
      </v-btn>
    </v-btn-toggle>
-->
    <v-btn-toggle v-if ="viewMode=='showAll' || viewMode=='showMap'" mandatory v-model="mouseMode" flat class="ml-3">
      <v-tooltip bottom>
        <span>Pan Map</span>
        <v-btn large value="move_map" flat slot="activator" @click="map.getCanvas().style.cursor = '';">
          <v-icon>pan_tool</v-icon>
        </v-btn>
      </v-tooltip>
      <v-tooltip bottom>
        <span>Toggle Visibility</span>
        <v-btn large value="toggle" flat slot="activator" @click="map.getCanvas().style.cursor = 'pointer';">
          <v-icon>check_box</v-icon>
        </v-btn>
      </v-tooltip>
      <v-tooltip bottom>
        <span>Add location</span>
        <v-btn large value="add" flat slot="activator" @click="map.getCanvas().style.cursor = 'pointer';">
          <v-icon>add_location</v-icon>
        </v-btn>
      </v-tooltip>
      <v-tooltip bottom>
        <span>Edit location</span>
        <v-btn large value="edit" flat slot="activator" @click="newLocationFlag, map.getCanvas().style.cursor = 'pointer';">
          <v-icon>edit_location</v-icon>
        </v-btn>
      </v-tooltip>

      <!-- <v-tooltip bottom>
      <span>Move location</span>
      <v-btn large value="move" flat slot="activator">
      <v-icon>pin_drop</v-icon>
    </v-btn>
  </v-tooltip> -->
</v-btn-toggle>
<v-btn-toggle flat class="ml-3">
  <v-tooltip bottom>
    <v-btn large flat @click="$root.$emit('toggleTheme')"slot="activator">
      <v-icon v-if="dark"  color="yellow">lightbulb</v-icon>
      <v-icon v-else >lightbulb</v-icon>
    </v-btn>
    <span>Toggle lights</span>
  </v-tooltip>
</v-btn-toggle>


<v-btn-toggle flat class="ml-3">
  <v-tooltip bottom>
    <v-btn large flat @click="zoomToFit()"slot="activator">
      <v-icon>search</v-icon>
    </v-btn>
    <span>Show active locations</span>
  </v-tooltip>
</v-btn-toggle>
<!-- <v-select solo small hide-details class="ml-3" label="Transceiver" :items="sensors" return-object item-text="name" v-model="selectedSensor"></v-select> -->
</v-toolbar>


<v-alert class="sideAlert" :value="successFlag" type="success" transition="fade-transition" :dismissible="true" >{{currentAlertMessage}}</v-alert>
<v-alert class="sideAlert" :value="failFlag" type="error" transition="fade-transition" :dismissible="true" >{{currentAlertMessage}}</v-alert>
<v-alert class="sideAlert" :value="infoFlag" type="info" transition="fade-transition" :dismissible="true" >{{currentAlertMessage}}</v-alert>
<v-alert class="sideAlert" :value="warningFlag" type="warning" transition="fade-transition" :dismissible="true" ><h1>{{currentAlertMessage}}</h1></v-alert>
<v-progress-linear  :hidden="!isLoading" class="loading" :indeterminate="true"> </v-progress-linear>
<mapbox v-if ="(viewMode =='showAll' || viewMode=='showMap')"
:map-options="mapOptions"
access-token="pk.eyJ1IjoibmFycm93dHV4IiwiYSI6ImNpZnRnbzVzNDAxdnd0a20wdG91ZHphOWcifQ.o13TzVvrJVe2J_WriuuEIw"
@map-load="loaded"
@map-click="clicked"
@map-mousemove="mouseMoved">

</mapbox>

<div v-if ="viewMode=='showAll' || viewMode=='showMap'" class="legend">
  <div class="pa-3">
    <div><span class="fill" :style="{background: colors.loss[0]}"></span> Deep Indoor Range</div>
    <div><span class="fill" :style="{background: colors.loss[1]}"></span> Indoor Range</div>
    <div><span class="fill" :style="{background: colors.loss[2]}"></span> Outdoor Range</div>

    <div v-if="pointMode == 'all'">
      <div><span class="circle" style="background: blue"></span> Enabled Gateway</div>
      <div><span class="circle" style="background: red"></span> Disabled Gateway</div>
    </div>

    <div v-if="pointMode == 'enabled' || pointMode == 'disabled'">
      <div v-for="type in types" :key="type.name">
        <span class="circle" :style="{background: type.color}"></span>
        {{ type.name }}
      </div>
    </div>

  </div>
</div>
<v-dialog v-model="editorOpen" lazy :max-width="320" :persistent="true">
  <v-card v-if="editorOpen">
    <v-card-text>
      <location-form v-model ="editingItem" :types="types" :newLocationFlag= "newLocationFlag"  :locations= "locations" v-on:valid="validLocation=$event[0]"></location-form>
    </v-card-text>
    <v-card-actions>
      <div v-if ="newLocationFlag">
        <v-btn flat color="black" @click="editorOpen = false, deleteLastItem(), setNewLocFalse()">Cancel</v-btn>
        <v-btn :disabled= "!validLocation" color="primary" flat @click="editorOpen = false, newLocationToDB(editingItem), setNewLocFalse(), hoveredLocationId = null">Save</v-btn>
      </div>
      <div v-if ="!newLocationFlag">
        <v-btn :disabled= "!validLocation" color="primary" flat @click="editorOpen = false, putLocationToDB(editingItem, true)">Save</v-btn>
        <v-btn flat color= "black" @click="editorOpen = false, revertItem()">Cancel</v-btn>
        <v-dialog lazy v-model="deleteConfirm" :max-width="240">
          <v-btn flat color="error" slot="activator">Delete</v-btn>
          <v-card>
            <v-card-text>
              Do you really want to delete this location?
            </v-card-text>
            <v-card-actions>
              <v-btn color="black" flat @click="deleteConfirm = false">Cancel</v-btn>
              <v-btn color="error" flat @click="deleteItem(editingItem)">Delete</v-btn>
            </v-card-actions>

          </v-card>
        </v-dialog>
      </div>
    </v-card-actions>
  </v-card>
</v-dialog>

<v-dialog v-model= "inputOpen" :max-width="700" :persistent="true" v-if="inputOpen">
    <csvInput
      :isImporting= "isImporting"
      :locations= "locations"
      :newLocations= "newLocationArray"
      :inputOpen="inputOpen"
      v-on:open="openEditor($event),newLocationFlag=false"
      v-on:closeCard="inputOpen=false,sidebarContent='data'"
      v-on:import="importAll()"
      v-on:unfixable="fireAlert('warning', 'Sorry cannot fix all Locations. Please fix manually')"
      v-on:dispErrors="fireAlert('warning', 'Please fix yourself:\n '+ $event[0]+ 'x EiRP,\n'
                                  + $event[1]+ 'x Height,\n'
                                  + $event[2]+ 'x Latitude and\n'
                                  + $event[3]+ 'x Longitude\n')"
      v-on:checked="isLoadingCheck=false"
      v-on:importOne="importOne($event[0])">
    </csvInput>
</v-dialog>

</div>

<div v-if ="viewMode=='showAll' || viewMode=='showLocations' && 'sidebarvisibility'" class="sidebar elevation-4 deacOf"  ref="sidebar">
  <v-toolbar ref="sidebarToolbar" style="z-index: 5" color="primary">
    <v-btn-toggle v-if="!bigScreen &&!smallestScreen" mandatory v-model="viewMode" flat class="ml-3">
      <v-btn large value="showMap" flat>
        Show Map
      </v-btn>
      <v-btn large value="showLocations" flat>
        Show Locations
      </v-btn>
    </v-btn-toggle>


    <v-tooltip bottom v-if="smallestScreen" flat class="ml-0">
      <v-btn flat icon @click="toggleMapLoc" slot="activator">
        <v-icon v-if="viewMode=='showMap'">list</v-icon>
        <v-icon v-else >map</v-icon>
      </v-btn>
      <span>Toggle Locations and Map</span>
    </v-tooltip>


    <v-btn-toggle v-if="!smallestScreen" mandatory v-model="sidebarContent" flat class="ml-2">
      <div>
        <v-btn large value="data">
          <v-icon>view_list</v-icon> Locations
        </v-btn>
        <v-btn large value="input">
          <v-icon>save</v-icon> CSV
        </v-btn>
        <v-btn large value="types">
          <v-icon>place</v-icon> Types
        </v-btn>
      </div>
    </v-btn-toggle>

   <v-menu top offset-y v-if ="(viewMode=='showAll' || viewMode=='showLocations') && smallestScreen">
      <v-btn
      slot="activator"
      color="blue"
      dark

      >
      Functionallity
    </v-btn>
    <v-list>
      <v-list-tile
      v-for="(item, index) in locationMethodSelection"
      :key="index"
      @click="sidebarContent=item.tag"
      >
      <v-list-tile-title>{{ item.title }}</v-list-tile-title>
    </v-list-tile>
  </v-list>
</v-menu>
<!--  <v-spacer v-if="sidebarContent !== 'data'"></v-spacer>-->

<v-text-field class="ml-3" solo clearable hide-details v-if="(sidebarContent == 'data')" label="Search" v-model="search"></v-text-field>

</v-toolbar>

<div class="mt-2" v-if="sidebarContent == 'input'">
  <v-layout v-if="!CSVimported">
    <v-flex xs12 sm4 text-xs-left>
      <div class=" ml-3" color="primary">
      <h2>Export:</h2>
    </div>
      <div>
      <v-btn class=" ml-3 mt-2" color="primary" @click="save('', null)">
        <v-icon>save</v-icon>
        Export all
      </v-btn>
    </div>
    <div class="mt-2">
      <v-btn class="ml-3" color="primary" @click="save('TypesOnly', exportType)">
        <v-icon>save</v-icon>
        Export all of type:
      </v-btn>
        <v-text-field class="ml-3 mt-1" solo hide-details clearable label="Type" v-model="exportType"></v-text-field>
      </div>
    <div class="mt-2">
    <v-btn class=" ml-3" color="primary" @click="save('VisibleOnly', null)">
      <v-icon>save</v-icon>
      Export all visible
    </v-btn>
  </div>
  </v-flex>
</v-layout>
<v-divider class="mt-3"></v-divider>
<div class=" ml-3 mt-3" color="primary">
<h2>Import:</h2>
</div>
<div>
  <v-text-field class="ml-3 mt-3"label="CSV Input" type="file" @change.native ="handleFileSelection"></v-text-field>
</div>



 <v-layout row v-if="CSVimported">
    <v-flex xs12 sm6 offset-sm3>
      <v-card>

        <v-card-title primary-title>
          <div>
            <div class="headline">{{importedLocations.length}} Locations in CSV file</div>
            <span class="grey--text">Please specify FROM which TO which of locations found should be imported
              (No changes will import all)</span>
          </div>
        </v-card-title>
        <v-layout row wrap>
         <v-flex xs6>
          <v-text-field
            v-model="CsvMin"
            label="FROM"
          ></v-text-field>
         </v-flex>
         <v-flex xs6>
           <v-text-field
             v-model="CsvMax"
             label="TO"
           ></v-text-field>
         </v-flex>
       </v-layout>
        <v-card-actions>
          <v-btn ref="imp" color="primary" @click="openImporter">Check Locations</v-btn>
          <v-btn color="secondary" @click="CSVimported=false">Cancel</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>

      </v-card>
      <h1 v-show="isLoadingCheck"> Loading ... </h1>
      <div>
      </div>
    </v-flex>
  </v-layout>
</div>




<div v-if="sidebarContent == 'data'" class="data-sidebar">
  <div v-if="!smallestScreen" flat class="primaryMiddel fs-14pt">
    Locations for project: {{currentProject.name}}
  </div>
  <div v-else flat class="primaryMiddel fs-14pt">
    Locations for project: {{currentProject.name | truncS}}
  </div>
  <v-data-table :items="locations" class="items" :headers="headers" :search="search" :pagination.sync="pagination" :rows-per-page-items="rowsPerPageItems">
    <template slot="items" slot-scope="props">
      <tr @click="openEditor(props.item)" v-on:mouseover="hovered = [props.item]" v-on:mouseleave="hovered = []">
        <td @click.prevent.stop ="putLocationToDB(props.item, false)" v-bind:class="{'selected-row': (props.item.id === hoveredLocationId)}">
          <v-checkbox hide-details v-model="props.item.visibility "></v-checkbox>
        </td>
        <td v-bind:class="{'selected-row': (props.item.id === hoveredLocationId)}">
          {{props.item.name | trunc}}
        </td>
        <td v-bind:class="{'selected-row': (props.item.id === hoveredLocationId)}">
          {{ props.item.height }} m
        </td>
        <td v-bind:class="{'selected-row': (props.item.id === hoveredLocationId)}">
          {{props.item.type}}
        </td>
        <td v-bind:class="{'selected-row': (props.item.id === hoveredLocationId)}">
          {{ props.item.eirp }} dBm
        </td>
        <td v-bind:class="{'selected-row': (props.item.id === hoveredLocationId)}">{{ getRange(props.item)[0] }} km</td>
        <td v-bind:class="{'selected-row': (props.item.id === hoveredLocationId)}">{{ getRange(props.item)[1] }} km</td>
        <td v-bind:class="{'selected-row': (props.item.id === hoveredLocationId)}">{{ getRange(props.item)[2] }} km</td>
        <td v-bind:class="{'selected-row': (props.item.id === hoveredLocationId)}"> {{props.item.text | trunc}}</td>
      </tr>
    </template>
  </v-data-table>
</div>

<div class="pa-3" v-if="sidebarContent == 'types'">
  <table>
    <tr v-for="type in types" :key="type.name">
      <td>
        <span class="circle" :style="{background: type.color}"></span>
      </td>
      <td>{{type.name}}</td>
      <td>
        <v-btn @click="setTypeVisibility(type.name, true)">On</v-btn>
        <v-btn @click="setTypeVisibility(type.name, false)">Off</v-btn>
      </td>
    </tr>
  </table>
</div>
</div>

<v-footer :value="true" color="primary" absolute height="auto">
  <v-btn depressed color="primary"  class="ma-0 ml-3" :to="{name: 'welcome'}">
    <v-icon >arrow_back</v-icon>
    <h4 v-if="smallestScreen" class="white--text"  >Back</h4>
    <h4 v-else class="white--text">    Back to Projects</h4>
  </v-btn>
  <v-spacer></v-spacer>
  <h1 v-if="!smallestScreen" class="white--text">{{currentProject.name}}</h1>
  <h1 v-else class="white--text">{{currentProject.name | truncS}}</h1>

  <v-spacer></v-spacer>

</v-footer>
</div>
</template>

<script>
const exampleCSV = 'height,lon,lat,name,type\n' +
'280,9.975833,53.563056,Fernsehturm,A\n' +
'20,10.02948760986328,53.584964633268704,,B\n' +
'30,10.020217895507812,53.55825752009741,,A\n' +
'35,9.96906280517578,53.5521390134073,,C\n' +
'120,10.009918212890625,53.57456921265326,,D\n' +
'20,9.939193725585938,53.56355951022927,,E\n' +
'10,9.964256286621094,53.595357497693,,F\n'

import Papa from "papaparse"
import {featureCollection, point, feature} from "@turf/helpers"
import bbox from "@turf/bbox"
import circle from "@turf/circle"
import generateName from "project-name-generator"
import union from "@turf/union"
import combine from "@turf/combine"
import difference from "@turf/difference"
import {zip, sumBy, uniq, map, find, take, flatMap, round} from "lodash"
import uuid from "uuid/v4"
import Color from "color"
import FileSaver from "file-saver"
import axios from "axios"


/*
* Data in a location:
* latitude
* longitude
* height
* name
* metadata - k/v object
* visibility
* */

const CATEGORY_COLORS = [
  "#a6cee3",
  "#1f78b4",
  "#b2df8a",
  "#33a02c",
  "#fb9a99",
  "#e31a1c",
  "#fdbf6f",
  "#ff7f00",
  "#cab2d6",
  "#6a3d9a",
  "#ffff99",
  "#b15928"
]

const INNER_COLOR = new Color("green")
const OUTER_COLOR = new Color("orange")

function countDeep(arr) {
  if (!Array.isArray(arr)) {
    return 1
  } else {
    return sumBy(arr, countDeep)
  }
}

function castFloat(num) {
  return num * 1
  console.log(num)
  if (typeof num === 'number') {
    return num
  } else if (typeof num === 'string') {
    if (num * 1 !== NaN) {
      return num * 1
    } else if (num.indexOf(",") !== -1) {
      return num.replace(/,/g, ".") * 1
    }
  }
}

function hata(f, base_height, height_correction, loss) {
  return Math.pow(10, (69.55 + 26.16 * Math.log10(f) - 13.82 * Math.log10(base_height) - height_correction - loss) / -Math.round(44.9 - 6.55 * Math.log10(base_height)))
}

function smallCity(f, mobile_height) {
  return 0.8 + (1.1 * Math.log10(f) - 0.7) * mobile_height - 1.56 * Math.log10(f)
}

const sensors = [
  // {
  //   vendor: "Semtech",
  //   name: "SX1276",
  //   minRSSI: -148
  // },
  {
    vendor: "Semtech",
    name: "SX1272",
    minRSSI: -137
  }
]

export default {
  name: "Map",
  components: {
    locationForm: require("./LocationForm").default,
    projectForm: require("./ProjectForm").default,
    csvInput: require("./CSVInput").default
  },
  props: {
    dark: {
      default: false,
      type: Boolean
    },
    //project
  },
  data() {
    return {
      currentProject: null,
      currentProjectName:"",
      projectSelected: true,
      locations: [],
      hovered: [],
      map: null,
      search: "",
      sensors,
      selectedSensor: sensors[0],
      pointMode: "all",
      mouseMode: "move_map",
      sidebarContent: "data",
      sidebarvisibility: true,
      pagination: {},
      editorOpen: false,
      editingItem: null,
      deleteConfirm: false,
      newLocationFlag: false,
      alertTimeout: 3000,
      warningTimeout: 5000,
      hoveredLocationId: null,
      currentAlertMessage: "",
      successFlag: false,
      failFlag: false,
      warningFlag: false,
      infoFlag:false,
      numNewLocations: null,
      newLocationArray: [],
      alertTimetamp: null,
      validLocation: false,
      tempItem:{},
      bigScreen: true,
      smallestScreen: false,
      viewMode: "showAll",
      inputOpen:false,
      rowsPerPageItems: [-1],
      CSVimported: false,
      CsvMin: null,
      CsvMax: null,
      isLoading: true,
      exportType: null,
      host:"",
      isLoadingCheck: false,
      isImporting: false,
      pagination: {
        rowsPerPage: null
},
      apiUrl: "",
      apiProjUrl: "",
      urlToProjects:"/",
      viewSelection: [
        { tag: 'none', title: 'Disable all locations' },
        { tag: 'disabled', title: 'Show disabled locations'},
        { tag: 'enabled', title:'Show enabled locations' },
        { tag: 'all', title:'Show all locations' }
      ],
      locationMethodSelection: [
        { tag: 'data', title: 'Show Locations' },
        { tag: 'input', title: 'Show CSV Import/Export'},
        { tag: 'types', title:'Show Types' }
      ]



    }
  },
  watch: {
    sidebarvisibility() {
      if (this.map) {
        this.$nextTick(() => this.map.resize())
      }
    },
    dark(nv) {
      if (this.map) {
        this.map.setStyle(this.mapOptions.style)
        this.map.once("styledata", () => this.loaded(this.map))
      }
    },
    mouseMode(nv, ov) {
      if (!this.map) return
      if (nv === "move_map") {
        this.map.dragPan.enable()
        this.map.doubleClickZoom.enable()
      }
      if (ov === "move_map") {
        this.map.dragPan.disable()
        this.map.doubleClickZoom.disable()
      }
    },

  },

  filters: {
  trunc: function (value) {
    if(typeof(value)!="undefined" && value!=null){
    if (value.length>15) return value.slice(0,14) + "..."
    else {
      return value
    }
  }
},
  truncS: function (value) {
    if(typeof(value)!="undefined" && value!=null){
      if (value.length>10) return value.slice(0,9) + "..."
      else {
        return value
      }
    }
  }
  },
  methods: {

    importOne(location){
      this.locations.push(location)
      this.newLocationToDB(location)

    },

    fetchAllLocations(){
      axios.get(this.apiProjUrl)
      .then(
        res => {
          let tempLocations = res.data.project.locations
            this.locationMapping(tempLocations)
        }
      )
      .catch(err => console.log(err))
    },

    validateNumber(input){
      return this.checkForNumber(input)&&!!input
    },

    validateRequired(input){
      return !!input
    },

    checkForNumber(input){
      if (!isNaN(parseFloat(input))&&input>0)
        return true
        else
        return false

    },

    openImporter(){
      this.isLoadingCheck = true

      if(!this.bigScreen){
      this.viewMode= "showMap"
    }
      this.newLocationArray = []

      if(this.validateNumber(this.CsvMin)
        && this.validateRequired(this.CsvMin)
        && this.validateNumber(this.CsvMax)
        && this.validateRequired(this.CsvMax)
        && parseInt(this.CsvMin)<=parseInt(this.CsvMax)
        && this.CsvMin <= this.importedLocations.length
        && this.CsvMax <= this.importedLocations.length

    ) {
      for(var i = this.CsvMin-1; i<this.CsvMax;i++){
        this.newLocationArray.push(this.importedLocations[i])
      }
    }
    else{
      this.fireAlert("warning", "Wrong input detected: Importing all")
      this.newLocationArray = this.importedLocations
      this.CsvMin = 1
      this.CsvMax = this.importedLocations.length
    }

    let self=this
    setTimeout(function(){
      self.inputOpen = true
      },
      200)

    },

    importAll(){
      this.locationMapping(this.newLocationArray)

      this.inputOpen=false
      this.sidebarContent='data'
    },


    toggleMapLoc(){
      if (this.viewMode=="showLocations"){
        this.viewMode="showMap"
      }
      else if (this.viewMode=="showMap") {
        this.viewMode="showLocations"
      }
    },

    handleShrinkTitle(){
      this.pagination.rowsPerPage = parseInt( (window.innerHeight-208)/48)-1
      //console.log(( (window.innerHeight-208)/48))

      if(window.innerWidth>1600){
        this.bigScreen=true
        this.viewMode ="showAll"
        this.smallestScreen=false

      }
      else  {
        this.bigScreen =false
        if(this.viewMode =="showAll")
        this.viewMode ="showMap"
        if(window.innerWidth<920){
        this.smallestScreen=true


      }
        else {
          this.smallestScreen=false
        }
      }

    },

    revertItem(){
      for(let i=0;i<this.locations.length;i++){
        if(this.tempItem.id==this.locations[i].id){
          this.locations[i].name = this.tempItem.name
          this.locations[i].type = this.tempItem.type
          this.locations[i].eirp = this.tempItem.eirp
          this.locations[i].height = this.tempItem.height
        }
      }
    },

    setNewLocFalse(){
      let self=this
      setTimeout(function(){
        self.newLocationFlag = false;
      },
      200)
    },

    fireAlert(type, message){

      this.currentAlertMessage = message
      this.successFlag = false
      this.failFlag = false
      this.infoFlag = false
      this.successFlag = false

      switch(type){
        case "success":
        this.successFlag = true
        this.setAlertTimeout()
        break;
        case "fail":
        this.failFlag = true
        this.setAlertTimeout()
        break;
        case "info":
        this.infoFlag = true
        this.setAlertTimeout()
        break;
        case "warning":
        this.warningFlag = true
        this.setAlertTimeout()
        break;


      }
    },

    setAlertTimeout(){
      let self=this
      setTimeout(function(){
        self.successFlag = false;
        self.failFlag = false;
        self.infoFlag = false;
      },
      self.alertTimeout);

      setTimeout(function(){

        self.warningFlag = false;
      },
      self.warningTimeout);
    },

    toggleSaveSuccessFlag(){
      if(this.saveSuccessFlag ==true){
        this.saveSuccessFlag = false
      }
      else{
        this.saveSuccessFlag =true
      }

    },

    deleteLocation(location){
      var id = location.id
      console.log('Try deleting Location',id)
      var config = {
        headers: { 'Content-Type': 'application/json' },
        responseType: 'blob'
      };
      axios.delete(this.apiUrl.concat(id), config)
      .then((response) => {
        console.log('deleted successfully')
        this.fireAlert("success", "Location " + location.name + " successfully deleted")
      }
    )
    .catch((err) => {
      this.fireAlert("fail", "Location not deleted")
    })
  },
   newLocationToDB(location){
     this.isImporting = true
    console.log('Try saving Location')
    console.log(location)
    var config = {
      headers: { 'Content-Type': 'application/json' },
      //  responseType: 'blob'
    };
    if(typeof(location.id)!="undefined"){
        delete location[id]
    }
    location.project_id = this.currentProject.id
    let locationObject = {location}
     return axios.post(this.apiUrl, locationObject, config)
    .then((response) => {
      console.log('saved successfully')
      location.id = response.data.id
      this.fireAlert("success", "Location successfully saved into Database")
      this.isImporting = false
      return location
    }
  )
  .catch((err) => {
    console.log('Not Saved')
    console.log(err)
    let indexToDelete= this.locations.indexOf(_.find(this.locations, ['name', location.name]))
    this.locations.splice(indexToDelete,1)
    this.fireAlert("fail", "Location not created")
    this.isImporting = false
  })

},

putLocationToDB(location,notificationFlag){
  console.log('Try editing Location')
  var config = {
    headers: { 'Content-Type': 'application/json' },
  };
  location.project_id = this.currentProject.id
  let id = location.id
  let locationObject = {location}
  axios.put(this.apiUrl.concat(id), locationObject, config)
  .then((response) => {
    console.log('edited successfully')
    if(notificationFlag){
      this.fireAlert("success", "Location "+ location.name+" successfully updated")
    }

  }
)
.catch((err) => {
  this.revertItem()
  this.fireAlert("fail", "Location not updated")
})
},

  locationMapping(locations){
  var promiseArray = []
  for (var i=0; i<locations.length; i++){

    let newItem = {
      name: locations[i].name,
      id: locations[i].id,
      latitude: parseFloat(locations[i].latitude),
      longitude: parseFloat(locations[i].longitude),
      type: locations[i].type,
      height: parseFloat(locations[i].height),
      eirp: parseFloat(locations[i].eirp),
      visibility: locations[i].visibility,
      text: locations[i].text
    }
    var self=this
    this.locations.push(newItem)
    if(typeof(locations[i].id)=='undefined'){
      self.newLocationToDB(newItem)
    }
  }
/*    if(typeof(locations[i].id)=='undefined'){
      let importPromise = new Promise(function(resolve,reject){
        self.newLocationToDB(newItem).then(resolve())

      })
      promiseArray.push(importPromise)
      }
    }
    if(promiseArray.length > 0){
      Promise.all(promiseArray).then(this.fetchAllLocations())
    }*/
},
openEditor(item) {
  this.editorOpen = true
  this.editingItem = item

  Object.assign(this.tempItem, item)


},

loaded(map) {
  map.resize()
  this.map = map
  this.isLoading = false;
  // add json sources
  const sources = ["locationSource", "radiusSource", "hoveredSource"]
  sources.forEach((source) => {
    let sourceData = this[source]
    map.addSource(source, {
      type: "geojson",
      data: sourceData
    })
    this.$watch(source, (nv) => map.getSource(source).setData(nv))
  })
  this.$watch("radiusSource", (nv, ov) => {
    if (nv.features.length != ov.features.length) {
      this.zoomToFit()
    }
  })

  map.addLayer({
    id: "locationRadius",
    source: "radiusSource",
    type: "fill",
    paint: {
      "fill-color": ["get", "color"],
      "fill-opacity": 0.35
    }
  })

  map.addLayer({
    id: "locationPoints",
    source: "locationSource",
    type: "circle",
    paint: {
      "circle-radius": {
        type: "exponential",
        stops: [
          [5, 1],
          [7, 3],
          [10, 5],
          [15, 10]
        ]
      },
      "circle-stroke-width": 1,
      "circle-stroke-color": ["get", "stroke-color"],
      "circle-color": ["get", "color"]
    }
  })

  map.addLayer({
    id: "locationLabels",
    source: "locationSource",
    type: "symbol",
    "minzoom": 10,
    layout: {
      "text-field": "{name}",
      "text-anchor": "top",
      "text-offset": [0, 1],
    },
    paint: {
      "text-halo-width": 1,
      "text-color": this.dark ? "white" : "black",
      "text-halo-color": this.dark ? "black" : "white"
    }
  })

  map.addLayer({
    id: "hoveredRadius",
    source: "hoveredSource",
    type: "fill",
    paint: {
      "fill-color": ["get", "color"],
      "fill-opacity": 0.2
    }
  })

  this.zoomToFit()
},
zoomToFit() {
  if (this.radiusSource.features.length > 0) {
    const bounds = bbox(this.radiusSource)

    this.map.fitBounds(bounds, {
      padding: 50,
      duration: 1000,
    })
  }
},
deleteItem(item) {
  this.locations = this.locations.filter(s => s != item)
  this.deleteConfirm = false
  if (item == this.editingItem) {
    this.deleteLocation(item)
    this.editingItem = null
    this.editorOpen = false
  }
},
deleteLastItem(){
  this.locations.pop()
},
mouseMoved(map, event) {
  let features = map.queryRenderedFeatures(event.point, {layers: ["locationPoints"]})
  //Debugging
  if(features!==[]){

    //console.log("feature => find(this.locations, {id: feature.properties.id})")
    //console.log(feature => find(this.locations, {id: feature.properties.id}))
    //console.log("features.map(feature => find(this.locations, {id: feature.properties.id}))")
    //console.log(features.map(feature => find(this.locations, {id: feature.properties.id})))
  }
  //debugging
  this.hovered = take(features.map(feature => find(this.locations, {id: feature.properties.id})), 10)
  if(typeof(this.hovered[0]) != 'undefined') {
    this.hoveredLocationId = this.hovered[0].id
  }
  else{
    this.hovered = take(features.map(feature => find(this.locations, {name: feature.properties.name})), 10)
    if(typeof(this.hovered[0]) != 'undefined') {
      this.hoveredLocationId = this.hovered[0].id
    }
    else {
      this.hoveredLocationId = null
    }
  }

},


clicked(map, event) {
  let features = map.queryRenderedFeatures(event.point, {layers: ["locationPoints"]})
  var id = null
  var location =null
  features.forEach(feature => {
    id = feature.properties.id
    location = find(this.locations, {id})
    if(typeof(id) != "undefined"){
      var location = find(this.locations, {id})
    }
      else {
          let name = feature.properties.name
          location = find(this.locations, {name})
      }

    if (this.mouseMode === "toggle") {
      location.visibility = !location.visibility
      this.putLocationToDB(location,false)
    }
    if (this.mouseMode === "edit") {
      this.openEditor(location)


    }
  })
  if (this.mouseMode === "add" && id === null) {
    this.newLocationFlag = true
    let newItem = {
      name: "",
      latitude: event.lngLat.lat,
      longitude: event.lngLat.lng,
      type: "",
      height: 10,
      eirp: 14,
      visibility: true,
      text: ""
    }
    this.locations.push(newItem)
    this.openEditor(newItem)


  }
},
clear() {
  this.locations = []
},
save(custom, types) {

  var customLocations = []
  switch(custom) {
  case "":
    customLocations = this.locations
    if (customLocations.length == 0){
      this.fireAlert("info", "There are no locations in this project")
      return
    }
    break
  case "TypesOnly":
    customLocations = this.locations.filter(location => location.type == this.exportType)
    if (customLocations.length == 0){
      this.fireAlert("info", "Nothing exported: No Location of this type")
      return
    }
    break
  case "VisibleOnly":
    customLocations = this.locations.filter(location => location.visibility)
    if (customLocations.length == 0){
      this.fireAlert("info", "Nothing exported: No Location visible")
      return
    }
    break

}

  let data = customLocations.map(location => ({
    visibility: location.visibility ? "TRUE" : "FALSE",
    name: location.name,
    height: location.height,
    type: location.type,
    eirp: location.eirp,
    lat: location.latitude,
    lon: location.longitude,
    text: location.text
  }))

  let csv = Papa.unparse(data, {
    header: true
  })

  let blob = new Blob([csv], {type: "text/plain;charset=utf-8"})
  var date = new Date(Date.now())
  date = date.getFullYear() + "-" + date.getMonth() + "-" + date.getDate() + "_" +  date.getHours() + "-" + date.getMinutes() + "-" + date.getSeconds();
  FileSaver.saveAs(blob, this.currentProject.name + custom +"_"+date+".csv")
},

finishedCSVRead(){

  this.CSVimported=false
  if(this.importedLocations.length > null){
  this.CSVimported=true
  event.target.files = null
  this.CsvMin = 1
  this.CsvMax = this.importedLocations.length
}
else{
  this.CSVimported=false
  this.fireAlert("warning","No Locations have been found")
}
},
handleFileSelection(event) {
  let files = event.target.files
  if(typeof(files[0])=="undefined"){
    this.CSVimported=false
    this.fireAlert("warning","No file selected")
    return
  }
  var self=this
  /*  function cb(){
  for(var i=0;i<self.newLocationArray.length;i++){
  self.newLocationToDB(self.newLocationArray[i])
}
self.locationMapping(self.newLocationArray)
}
*/
function cb(){
self.finishedCSVRead()
}
function parseErr(){
  self.CSVimported=false
  self.fireAlert("warning","Not able to read file")
}
this.parseCSV(files[0], cb, parseErr)

},
parseCSV(csv, onComplete, onError) {
  this.importedLocations = []
  const opts = {
    header: true,
    complete: onComplete,
    error: onError,
    step: ({data}, parser) => {
      let newLocations = data.map(({lat, lon, height, name, type, eirp, visibility, text}) => {
        return {
          //id: uuid(),
          latitude: castFloat(lat) || "",
          longitude: castFloat(lon) || "",
          height: castFloat(height) || "",
          visibility: visibility !== "FALSE",
          type: type || "" ,
          name: name || "",
          eirp: castFloat(eirp) || "",
          text: text || ""
        }
      })
      this.importedLocations = this.importedLocations.concat(newLocations)

    }
  }
  Papa.parse(csv, opts)
},
radius(location, loss) {
      return hata(868, location.height, smallCity(868, 1), loss + location.eirp)

},
getRange(location) {
  return this.losses
  .map(loss => this.radius(location, loss))
  .map(radius => round(radius, 2))
},
generateCircle(loss) {

  return (location) => {
    let radius = this.radius(location, loss)
    return circle([location.longitude, location.latitude], radius, {units: "kilometers", steps: 32})
  }

},
generateSegmentedRadiusUnion(locations, innerColor, outerColor) {
  if(this.newLocationFlag){
    locations.pop()
  }
  else if(this.editorOpen) {
    let indexToDelete= locations.indexOf(_.find(locations, ['id',this.editingItem.id]))
    locations.splice(indexToDelete,1)
  }
  let unions =
  flatMap(this.losses, (loss, index) => {
    let circles =
    locations
    .map(this.generateCircle(loss))

    if (circles.length == 0) {
      return []
    }

    let area = union.apply(null, circles)
    area.properties.color = innerColor.mix(outerColor, index / (this.losses.length - 1)).rgb().string()
    return area
  })
  unions = map(unions, (area, index) => {
    if (index > 0) {
      let smaller = unions[index - 1]
      area = difference(area, smaller)
    }

    return area
  })

  return featureCollection(unions)
},
setTypeVisibility(type, visibility) {
  this.locations.forEach((location) => {
    if(location.type == type) {
      location.visibility = visibility
      this.putLocationToDB(location, false)
    }
  })
},
calculateRows() {
  let sidebar = this.$refs.sidebar
  let toolbar = this.$refs.sidebarToolbar.$el
  let space = sidebar.clientHeight - toolbar.clientHeight

  space -= 57 // top bar
  space -= 59 // bottom bar

  return Math.floor(space / 48);
}
},

created() {

  try {

    this.host = this.$route.params.host
    this.currentProject = this.$route.params.project;
    this.apiUrl = this.host+"/api/location/"
    this.apiProjUrl = this.host+"/api/project/"+this.currentProject.id
    this.locationMapping(this.$route.params.project.locations);


  }
  catch(err) {
  window.location.replace(this.urlToProjects);
}

},
mounted() {
  //this.$nextTick(() => this.pagination.rowsPerPage = this.calculateRows())

},
computed: {
  mapOptions() {
    return {
      style: `mapbox://styles/mapbox/${this.dark ? 'dark' : 'streets'}-v9`
    }
  },
  // returns losses for deep indoor, indoor, outside ranges
  losses() {
    let loss = -this.selectedSensor.minRSSI
    return [Math.max(30, loss - 20), Math.max(30, loss - 15), Math.max(30, loss)]
  },
  locationSource() {

    let points = this.locations
    .filter((location) => {
      switch (this.pointMode) {
        case "none":
        return false
        case "all":
        return true
        case "enabled":
        return location.visibility
        case "disabled":
        return !location.visibility
      }
    })
    .map(
      (location) => {
        let color = "blue"

        switch (this.pointMode) {
          case "none":
          color = "transparent"
          break
          case "all":
          color = location.visibility ? "blue" : "red"
          break
          case "enabled":
          case "disabled":
          color = find(this.types, {name: location.type}).color
          break
        }
        let props = {
          height: location.height,
          name: location.name,
          color,
          id: location.id,
          "stroke-color": (new Color(color)).mix(new Color("black"), 0.5).rgb().toString()
        }
        return point([location.longitude, location.latitude], props)
      }
    )
    return featureCollection(points)
  },
  hoveredSource() {
    if (this.hovered.length == 0 || typeof this.hovered[0] === "undefined") {
      return featureCollection([])
    }
    let innerColor = new Color("blue")
    let outerColor = new Color("violet")
    return this.generateSegmentedRadiusUnion(this.hovered, innerColor, outerColor)
  },
  radiusSource() {
        return this.generateSegmentedRadiusUnion(this.locations.filter(({visibility}) => visibility), INNER_COLOR, OUTER_COLOR)
  },
  verts() {
    return sumBy(this.radiusSource.features, (feature) => sumBy(feature.geometry.coordinates, countDeep))
  },
  types() {
    return uniq(map(this.locations, "type")).map((name, index) => {
      return {
        name,
        color: CATEGORY_COLORS[index % CATEGORY_COLORS.length]
      }
    })
  },
  headers() {
    return [
      {text: "Visibility", value: "visibility", align: "left", sortable: false}, // "sortable: false" because rows change while click and change 2 rows accidently (hotfix )
      {text: "Name", value: "name", align: "left"},
      {text: "Height", value: "height", align: "left"},
      {text: "Type", value: "type", align: "left"},
      {text: "EiRP", value: "eirp", align: "left"},
      {text: "Deep Indoor", value: "", align: "left", sortable: false},
      {text: "Indoor", value: "", align: "left", sortable: false},
      {text: "Outside", value: "", align: "left",sortable: false},
      {text: "Note", value: "text", align: "left"}
    ]
  },


  tablePagination: {
    set(nv) {
      let rowsPerPage = this.pagination.rowsPerPage
      this.pagination = nv
      this.pagination.rowsPerPage = rowsPerPage
      console.log(nv)
    },
    get() {
      return this.pagination
    }
  },
  colors() {
    let loss = []

    for (let i = 0; i < this.losses.length; i++) {
      loss.push(INNER_COLOR.mix(OUTER_COLOR, i / (this.losses.length - 1)))
    }

    return {
      loss
    }
  }
},
}
</script>

<style scoped>
#map {
  width: 100%;
  height: 100%;
  max-height: calc(100vh - 64px);
}
.content {
  height: 100%;
}
.content > .map {
  width: 66vw;
}
.sidebar {
  width: 100vw;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
}

@media(max-width: 1600px) {
  .sidebar {
    width: 100%;
    height: 100%;

    width: 1600vw;
    overflow-y: scroll;
    display: flex;
    flex-direction: column;
  }
}

.circle {
  display: inline-block;
  width: 1em;
  height: 1em;
  border-radius: 0.5em;
}
.data-sidebar {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-grow: 0;
}

.legend {
  position: fixed;
  background: white;
  z-index: 1;
  margin: 7px;
  margin-bottom: 35px;
  bottom: 0;
  left: 0;
  transition: background-color 200ms ease;
}

.theme--dark .legend {
  background: #444;
}

.legend .fill {
  display: inline-block;
  height: 0.75em;
  width: 5ch;
}

.legend .circle {
  display: inline-block;
  height: 1em;
  width: 1em;
  border-radius: 0.5em;
  border: 1px solid rgba(0, 0, 0, 0.5);
}

.toolbar__content > .input-group, .toolbar__content > .btn {
  min-height: 44px;
}
.fade-transition-enter-active, .fade-transition-leave-active {
  transition: opacity 1s;
}
.fade-transition-enter, .fade-transition-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
div.btn__content {
  padding: 0;
}

.selected-row {
  background-color: #4CAF50;
}
.lightgrey {
  font-size: 14pt;
  font-style:italic;
  color: #555555;
  opacity: 0.5;
  height: 52px;
  margin: auto;
  position:relative;
  top:12px
}

.primaryMiddel {
  font-size: 14pt;
  color: #3675cc;
  height: 52px;
  margin: auto;
  position:relative;
  top:12px
}
.fs-14pt{
  font-size: 14pt;
}
.sidebar{
  width: 700px;
}
@media (max-width: 880px) {
  .style{
    height: 112px;
  }
}
.sideAlert{
  z-index: 100;
  position: fixed;
  bottom: 60px;
  right: 40px;
  height: 59px;
}

.deacOf{

  overflow: auto;

}

.loading{
  z-index: 100
}
</style>



// WEBPACK FOOTER //
// src/components/Map.vue